




















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { YoutubeElement as YoutubeElementType, ElementActionsKeys, ElementActionsPayload } from '@/store/types/element';
import YoutubeToolbar from '../Toolbars/YoutubeToolbar.vue';
import MediaFileOverlay from './MediaFileOverlay.vue';
import { RootGettersReturns } from '@/store/types';

@Component({
  components: {
    YoutubeToolbar,
    MediaFileOverlay,
  },
})
export default class YoutubeElement extends Vue {
  @Prop(String) id!: string;

  @Prop(Boolean) selected!: boolean;
  @Prop(Boolean) doubleSelected!: boolean;
  @Prop({ type: Object }) element!: YoutubeElementType;

  @Getter isGuest!: RootGettersReturns['isGuest'];

  @Action(ElementActionsKeys.SET_DOUBLE_SELECTED) setDouble!: (
    payload: ElementActionsPayload['SET_DOUBLE_SELECTED']
  ) => void;
  @Action(ElementActionsKeys.UPDATE_ELEMENT) updateElement!: (payload: ElementActionsPayload['UPDATE_ELEMENT']) => void;

  public playing = false;
  public player = null;
  public displayedOverlay = false;

  startedPlaying() {
    if (!this.isGuest) {
      this.updateElement({
        ...this.element,
        data: {
          ...this.element.data,
          state: 'playing',
        },
      });
    }
    this.playing = true;
  }

  stopPlaying() {
    if (!this.isGuest) {
      this.updateElement({
        ...this.element,
        data: {
          ...this.element.data,
          state: 'paused',
        },
      });
    }
    this.playing = false;
  }

  @Watch('doubleSelected')
  doubleClicked(newVal: boolean) {
    this.$parent.$parent.$emit('changeMoveable', !newVal);
    this.setDouble(newVal);
  }

  private wasSelected = false;

  @Watch('selected')
  async isSelected(newVal: boolean) {
    if (this.wasSelected != newVal) {
      this.wasSelected = newVal;
      if (!newVal) {
        this.setDouble(newVal);
      }
    }
  }

  @Watch('element', { deep: true })
  elementUpdate(newVal: YoutubeElementType, oldValue: YoutubeElementType) {
    if (this.isGuest) {
      if (newVal.data.state !== oldValue.data.state) {
        if (newVal.data.state === 'playing') {
          this.playerAsMedia.play();
        } else {
          this.playerAsMedia.pause();
        }
      }
    }
  }

  get playerAsMedia() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const player = this.player as any;
    return {
      play: player?.playVideo,
      pause: player?.pauseVideo,
    };
  }

  mounted() {
    this.$parent.$parent.$emit('updateMoveableComponent', {
      keepRatio: true,
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.player = (this.$refs.youtube as any).player;
    if (this.element.data.state === 'playing') {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.playerAsMedia.play();
    }
  }

  beforeDestroy() {
    this.setDouble(false);
  }
}
